import React from 'react';
import AdminPortfolioList from '../components/admin/portfolio/AdminPortfolioList';

const AdminPortfolio = () => {
    return (
        <AdminPortfolioList />
    );
};

export default AdminPortfolio;